import { memo, useState, useEffect } from 'react';
import { RawHtml } from '@divlab/divanui';

import formatPrice from '@Utils/formatPrice';
import Variant from '../Variant';
import Price from '../Price';
import styles from './StepPrice.module.css';

import type { VariantData } from '@Pages/PageQuizMattrasses/typings';
import type { HTMLAttributes, FC, MouseEvent } from 'react';

export interface RangeData {
  value: number;
  content: string;
}

export type OnChangeRange = (e: MouseEvent, range: number | string) => void;

export interface StepPriceProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  className?: string;
  variants: VariantData[];
  ranges: Array<number | string>;
  onChangeRange?: OnChangeRange;
}

const StepPrice: FC<StepPriceProps> = (props) => {
  const { variants, ranges, onChangeRange, ...restProps } = props;

  const [selectedRange, setSelectedRange] = useState<number | string>(null);

  const handleChangeRange: OnChangeRange = (e, range) => {
    setSelectedRange(range);
    if (onChangeRange) onChangeRange(e, range);
  };

  useEffect(() => {
    if (!ranges || ranges.length === 0) return;
    setSelectedRange(ranges[ranges.length - 1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div {...restProps}>
      <div className={styles.variantsWrapper}>
        {variants.map((variant) => (
          <Variant key={variant.id} variant={variant} />
        ))}
      </div>

      <div className={styles.prices}>
        {ranges.map((range) => (
          <Price
            className={styles.price}
            key={range}
            selected={range === selectedRange}
            onClick={(e: MouseEvent) => handleChangeRange(e, range)}
          >
            {typeof range === 'number' ? (
              <RawHtml html={`до ${formatPrice(range)}{currency}`} />
            ) : (
              <span>{range}</span>
            )}
          </Price>
        ))}
      </div>
    </div>
  );
};

export default memo(StepPrice);
